export type Partner = {
  slug: string;
  name: string;
  category: string;
  url: string;
  tagline: string;
  body: string;
  page?: string;
};

export const partners: Partner[] = [
  {
    slug: "lili",
    name: "Lili Business Banking",
    category: "Business banking",
    url: "https://lili.pxf.io/nX2BE6",
    tagline: "Open a business checking account for your LLC",
    body: "Business checking built for small operators, with expense tracking and tax buckets. Use it for reserves, rent deposits, and closing funds held in the entity's name.",
    page: "/business-setup/business-bank-account",
  },
  {
    slug: "simply-approved-business-loans",
    name: "Simply Approved Business Loans",
    category: "Business credit & capital",
    url: "https://simplyapprovedbusinessloans.com/",
    tagline: "Working capital that helps build business credit",
    body: "Business lines and term financing for your operating entity — useful for rehab carry, marketing, and establishing a credit file under the LLC rather than your personal name.",
    page: "/business-setup/business-loans",
  },
  {
    slug: "dandb-duns",
    name: "Dun & Bradstreet",
    category: "Business credit file",
    url: "https://dandb.7eer.net/MAEooY",
    tagline: "Get your DUNS number and business credit file",
    body: "A DUNS number is the identifier most business credit reporting is tied to. Establishing it early gives your entity a credit history separate from your personal profile.",
    page: "/business-setup/duns-number",
  },
  {
    slug: "steadily",
    name: "Steadily",
    category: "Landlord insurance",
    url: "https://simplyapproved.steadilypartner.com/partner/indication",
    tagline: "Landlord and rental property insurance quotes",
    body: "Landlord policies written for investment property, including short-term rental and vacant/renovation coverage. Lenders require evidence of insurance with mortgagee clause before closing.",
    page: "/business-setup/landlord-insurance",
  },
  {
    slug: "doorloop",
    name: "DoorLoop",
    category: "Property management software",
    url: "https://doorloop.pxf.io/PO6WW6",
    tagline: "Track rents, leases, and expenses in one place",
    body: "Property management software for rent collection, lease tracking, maintenance, and owner reporting — the same records underwriting asks for on portfolio and refinance files.",
    page: "/business-setup/property-management-software",
  },
  {
    slug: "theitin",
    name: "TheITIN",
    category: "ITIN",
    url: "https://theitin.com/ref/304/",
    tagline: "ITIN applications for non-US investors",
    body: "Certifying Acceptance Agent service for foreign national investors who need an Individual Taxpayer Identification Number for US tax filings and banking.",
    page: "/business-setup/itin",
  },
  {
    slug: "doola",
    name: "doola",
    category: "LLC formation",
    url: "https://partnersps.doola.com/4plupih4o99l",
    tagline: "Form your LLC and get your EIN",
    body: "Entity formation, registered agent, EIN, and operating agreement — including formations for non-US founders. Our loans are vested in an entity, so this comes first.",
    page: "/business-setup/llc",
  },
  {
    slug: "closed-title",
    name: "Closed Title",
    category: "Title & closing",
    url: "https://www.closedtitle.com/simplyapprovedmortgages",
    tagline: "Title search, escrow, and closing services",
    body: "Title commitment, search, escrow, and closing coordination for investor transactions in an entity, including purchases, refinances, and assignments.",
    page: "/business-setup/title-services",
  },
];

export function partnerBySlug(slug: string) {
  return partners.find((p) => p.slug === slug);
}
